import { useContext, useEffect } from "react";
import { MapContext } from "../../MapContext";
import { registerOlInteraction } from "../helpers";

import { DragZoom } from "ol/interaction";

export default function DragZoomInteraction(props) {
  const context = useContext(MapContext);

  const options = {
    className: undefined,
    condition: undefined,
    duration: undefined,
    out: undefined,
    minArea: undefined
  };

  const events = {
    boxdrag: undefined,
    boxend: undefined,
    boxstart: undefined,
    change: undefined,
    "change:active": undefined,
    error: undefined,
    propertychange: undefined
  };

  useEffect(
    () =>
      registerOlInteraction(context, DragZoom, props, options, events),
    []
  );

  return null;
}
